// Os 10 modelos prontos de story do LucraLink (textos e cores proprios) e o
// sobreposto padrao dos templates enviados pelo usuario. Referencias:
// "preset:<key>" ou "custom:<uuid>" (story_settings / story_render_requests).
export const STORY_PRESET_PREFIX = "preset:";
export const STORY_CUSTOM_PREFIX = "custom:";
function text(id, box, value, color, opts = {}) {
    return {
        id,
        kind: "text",
        box,
        rotation: 0,
        text: value,
        color,
        background: opts.bg ?? null,
        align: opts.align ?? "center",
        bold: opts.bold ?? true,
    };
}
function badge(id, box, value, color, textColor, shape, rotation = 0) {
    return { id, kind: "badge", box, rotation, text: value, color, textColor, shape };
}
/** Disposicao padrao: chamada no topo, foto ao centro, dados embaixo. */
function standard(header, p, photoY = 0.16) {
    return {
        background: p.background,
        photo: { box: { x: 0.12, y: photoY, w: 0.76, h: 0.4 }, card: p.card, fit: "contain" },
        layers: [
            text("header", { x: 0.08, y: 0.05, w: 0.84, h: 0.07 }, header, p.ink),
            badge("discount", { x: 0.68, y: photoY - 0.03, w: 0.24, h: 0.135 }, "-{discountPercent}", p.accent, p.accentInk, "circle", 8),
            text("title", { x: 0.08, y: 0.62, w: 0.84, h: 0.1 }, "{title}", p.ink, { bold: false }),
            text("original", { x: 0.2, y: 0.725, w: 0.6, h: 0.035 }, "De {originalPrice}", p.ink, { bold: false }),
            badge("price", { x: 0.18, y: 0.77, w: 0.64, h: 0.075 }, "{price}", p.accent, p.accentInk, "pill"),
            text("coupon", { x: 0.15, y: 0.865, w: 0.7, h: 0.04 }, "Cupom: {coupon}", p.ink),
            text("cta", { x: 0.25, y: 0.925, w: 0.5, h: 0.035 }, "Toque no link", p.ink, { bold: false }),
        ],
    };
}
/** Disposicao em faixa: foto grande no topo e bloco de dados colorido embaixo. */
function banded(header, p) {
    return {
        background: p.background,
        photo: { box: { x: 0.06, y: 0.1, w: 0.88, h: 0.46 }, card: p.card, fit: "contain" },
        layers: [
            text("header", { x: 0.06, y: 0.025, w: 0.88, h: 0.055 }, header, p.ink),
            text("title", { x: 0.06, y: 0.6, w: 0.88, h: 0.1 }, "{title}", p.accentInk, { bg: p.accent, bold: true }),
            text("original", { x: 0.1, y: 0.72, w: 0.8, h: 0.035 }, "Antes {originalPrice}", p.ink, { bold: false }),
            text("price", { x: 0.1, y: 0.76, w: 0.8, h: 0.08 }, "{price}", p.ink),
            badge("discount", { x: 0.3, y: 0.85, w: 0.4, h: 0.05 }, "{discountPercent} OFF", p.accent, p.accentInk, "ribbon"),
            text("coupon", { x: 0.1, y: 0.915, w: 0.8, h: 0.04 }, "Use o cupom {coupon}", p.ink, { bold: false }),
        ],
    };
}
const solid = (color) => ({ kind: "solid", color });
const gradient = (from, to) => ({ kind: "gradient", from, to });
export const STORY_PRESETS = Object.freeze([
    { key: "classico", name: "Clássico", design: standard("OFERTA DO DIA", { background: solid("#f5f1e8"), card: "#ffffff", ink: "#1d1d1b", accent: "#1f8a4c", accentInk: "#ffffff" }) },
    { key: "relampago", name: "Relâmpago", design: standard("OFERTA RELÂMPAGO", { background: gradient("#ff6a00", "#ee0979"), card: "#ffffff", ink: "#ffffff", accent: "#ffe14d", accentInk: "#1d1d1b" }) },
    { key: "noturno", name: "Noturno", design: standard("ACHADO DA NOITE", { background: gradient("#0f2027", "#2c5364"), card: "#ffffff", ink: "#ffffff", accent: "#00d084", accentInk: "#0f2027" }) },
    { key: "minimal", name: "Minimal", design: standard("vale a pena", { background: solid("#ffffff"), card: null, ink: "#111111", accent: "#111111", accentInk: "#ffffff" }) },
    { key: "cupom", name: "Cupom", design: banded("CUPOM LIBERADO", { background: solid("#fff4d6"), card: "#ffffff", ink: "#3b2a00", accent: "#7c3aed", accentInk: "#ffffff" }) },
    { key: "tropical", name: "Tropical", design: banded("PROMOÇÃO DE VERÃO", { background: gradient("#00b09b", "#96c93d"), card: "#ffffff", ink: "#ffffff", accent: "#ff5e62", accentInk: "#ffffff" }) },
    { key: "elegante", name: "Elegante", design: standard("SELEÇÃO ESPECIAL", { background: solid("#1b1b1f"), card: "#2a2a31", ink: "#f2e6c9", accent: "#c9a227", accentInk: "#1b1b1f" }, 0.18) },
    { key: "etiqueta", name: "Etiqueta", design: banded("PREÇO BAIXOU", { background: solid("#e8f1ff"), card: "#ffffff", ink: "#0b2a5b", accent: "#e63946", accentInk: "#ffffff" }) },
    { key: "pastel", name: "Pastel", design: standard("ACHADINHO", { background: gradient("#fbc2eb", "#a6c1ee"), card: "#ffffff", ink: "#2d2a4a", accent: "#2d2a4a", accentInk: "#ffffff" }) },
    { key: "destaque", name: "Destaque", design: banded("MAIS VENDIDO", { background: gradient("#232526", "#414345"), card: "#ffffff", ink: "#ffffff", accent: "#ffb703", accentInk: "#232526" }) },
]);
/** Sobreposto dos templates proprios: o centro recebe foto, nome e preco. */
export const CUSTOM_STORY_DESIGN = Object.freeze({
    background: { kind: "image" },
    photo: { box: { x: 0.16, y: 0.24, w: 0.68, h: 0.34 }, card: "#ffffff", fit: "contain" },
    layers: [
        text("title", { x: 0.1, y: 0.61, w: 0.8, h: 0.09 }, "{title}", "#ffffff", { bg: "#000000", bold: false }),
        badge("price", { x: 0.2, y: 0.72, w: 0.6, h: 0.07 }, "{price}", "#1f8a4c", "#ffffff", "pill"),
        badge("discount", { x: 0.66, y: 0.205, w: 0.22, h: 0.12 }, "-{discountPercent}", "#e63946", "#ffffff", "circle", 8),
        text("coupon", { x: 0.15, y: 0.805, w: 0.7, h: 0.04 }, "Cupom: {coupon}", "#ffffff", { bg: "#000000" }),
    ],
});
export const DEFAULT_STORY_REF = `${STORY_PRESET_PREFIX}classico`;
const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
/** "preset:<key>" (modelo existente) ou "custom:<uuid>". null = invalida. */
export function parseStoryRef(ref) {
    if (typeof ref !== "string")
        return null;
    if (ref.startsWith(STORY_PRESET_PREFIX)) {
        const key = ref.slice(STORY_PRESET_PREFIX.length);
        return STORY_PRESETS.some((p) => p.key === key) ? { kind: "preset", key } : null;
    }
    if (ref.startsWith(STORY_CUSTOM_PREFIX)) {
        const id = ref.slice(STORY_CUSTOM_PREFIX.length);
        return UUID_RE.test(id) ? { kind: "custom", id: id.toLowerCase() } : null;
    }
    return null;
}
/** Design do modelo pronto (fallback no Clássico). */
export function storyPresetDesign(key) {
    return (STORY_PRESETS.find((p) => p.key === key) ?? STORY_PRESETS[0]).design;
}
/** Template efetivo: o da loja, senao o padrao geral, senao o Clássico. Refs
 *  invalidas (ex.: template proprio apagado) caem para o proximo nivel. */
export function resolveStoryRef(settings, provider, customIds) {
    const usable = (ref) => {
        const parsed = parseStoryRef(ref);
        return parsed !== null && (parsed.kind === "preset" || customIds.has(parsed.id));
    };
    const byProvider = provider ? settings.byProvider[provider] : undefined;
    if (usable(byProvider))
        return byProvider;
    if (usable(settings.defaultRef))
        return settings.defaultRef;
    return DEFAULT_STORY_REF;
}
//# sourceMappingURL=presets.js.map